module.exports = __webpack_public_path__ + "img/revenue.0d6fd04.webp";